/* eslint-disable react/no-array-index-key */
import React from 'react';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import CancelIcon from '@material-ui/icons/Cancel';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import ReportProblemIcon from '@material-ui/icons/ReportProblem';
import globals from '../../../globals/communityGlobals';

export default function WarningSidePanel({ warningMessage, events, errorMsg = null }) {
  const locale = globals.getArea('userActions');

  const errorPlaceholder = () => {
    if (errorMsg === null) return null;

    return (
      <span className="form-validation-error">
        {errorMsg ? errorMsg.message.split('\n').map((it, i) => <p key={i}>{it}</p>) : null}
      </span>
    );
  };

  const headerRender = () => {
    return (
      <div className="sidePanel-header is-warning">
        <div className="sidePanel-header-subtitle">
          <Box display="flex">
            <Box flexGrow={1} py={1}>
              <Typography variant="subtitle1">Confirm</Typography>
            </Box>
            <Box>
              <IconButton onClick={() => events.handleWarningPanel(false)}>
                <CancelIcon />
              </IconButton>
            </Box>
          </Box>
        </div>
      </div>
    );
  };

  const contentRender = () => {
    return (
      <div className="sidePanel-content">
        {errorPlaceholder()}
        <div className="information-text-content">
          <ReportProblemIcon className="icon-warning-style" />
          <span className="information-text-title">{locale.getMsg('warning')}</span>
          <span className="information-text-description">{warningMessage}</span>
        </div>
      </div>
    );
  };

  const footerRender = () => {
    return (
      <div className="sidePanel-footer">
        <div className="sidePanel-buttons">
          <div className="sidePanel-BackButton">
            <Button
              variant="contained"
              color="secondary"
              style={{ marginRight: '10px' }}
              onClick={() => events.handleWarningPanel(false)}
            >
              {locale.getMsg('back')}
            </Button>
          </div>
          <div className="sidePanel-saveButton">
            <Button variant="contained" color="primary" onClick={events.onConfirmWarning}>
              {locale.getMsg('yes')}
            </Button>
          </div>
        </div>
      </div>
    );
  };

  return (
    <section className="side-panel-content-wrapper">
      <SwipeableDrawer anchor="right" open onOpen={() => {}} onClose={() => {}}>
        <div className="sidePanel-wrapper" style={{ width: '350px' }}>
          {headerRender()}
          {contentRender()}
          {footerRender()}
        </div>
      </SwipeableDrawer>
    </section>
  );
}
